<template>
  <div>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="vendors"
        :loading="isLoading"
        :no-data-text="$t('table.noResults')"
        :loading-text="$t('table.loading')"
        :items-per-page="itemsPerPage"
        mobile-breakpoint="20"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name ? item.name : '---' }}
        </template>
        <template v-slot:[`item.document`]="{ item }">
          {{ formatDocument(item.document) }}
        </template>
        <template v-slot:[`item.date_created`]="{ item }">
          {{ item.date_created ? formatDate(item.date_created) : '---' }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="createEditVendor(item.id)" class="mx-1" small icon>
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>

          <v-btn @click="handleDeleteVendorModal(item.id)" small icon>
            <v-icon small> mdi-delete </v-icon>
          </v-btn>

          <v-divider class="mh-15 ml-2 mr-4" vertical />

          <v-btn :to="`/price-table/${item.id}`" color="primary" outlined small>
            <div class="d-flex">
              <v-icon class="mr-1" small> mdi-table-headers-eye </v-icon>
              <span class="caption">
                {{ $t('priceTable.label.seeTablePrice') }}
              </span>
            </div>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <VendorsCreateEdit ref="createVendor" />
    <VendorsDelete />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDocument } from '@/util/document'
import { catalogDateWithoutTime } from '@/util/catalog'
import { vendorsHeader } from '@/views/vendor/listHeaders'

import VendorsCreateEdit from './vendor/components/VendorsCreateEdit'
import VendorsDelete from './vendor/components/VendorsDelete'

export default {
  name: 'VendorsList',

  components: {
    VendorsCreateEdit,
    VendorsDelete,
  },

  data() {
    return {
      formatDocument,
      headers: vendorsHeader,
      formatDate: catalogDateWithoutTime,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'vendors', 'itemsPerPage']),
  },

  methods: {
    ...mapActions([
      'fetchVendors',
      'handleDeleteVendorModal',
      'handleOpenCreateEditVendorModal',
    ]),

    createEditVendor(id) {
      this.$refs.createVendor?.resetFields()
      this.handleOpenCreateEditVendorModal(id)
    },
  },

  mounted() {
    this.fetchVendors()
  },
}
</script>
